export default {
  messages: {
    acceptCookieUsage: {
      defaultMessage: "Vi använder cookies för att förbättra användarupplevelsen :)",
      defaultButtonText: "Jag godkänner det"
    }
  }
}